// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth,GoogleAuthProvider } from "firebase/auth";
// Your web app's Firebase configuration

const firebaseConfig = {
    apiKey: "AIzaSyDUN7hu4x5kJit-CAufDWBkUt6SpPGMxvI",
    authDomain: "nextfutureai-social-login.firebaseapp.com",
    projectId: "nextfutureai-social-login",
    storageBucket: "nextfutureai-social-login.firebasestorage.app",
    messagingSenderId: "718605950434",
    appId: "1:718605950434:web:9b8cdc17ac12dd81aa6dbb"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app)
const provider = new GoogleAuthProvider()

export {auth,provider}